



















































import { State } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';
import { Farm } from '@/models/farm';

@Component
export default class App extends Vue {
  @State('farms') private farmsState: any;
  @State('currentFarm') private currentFarmState: any;

  private currentFarm: any = {};
  private allFarms: Farm[] = [];

  // TODO: Base this off the router
  private items = [
    {
      id: 1,
      title: 'Home',
      linkTo: '/home',
    },
    {
      id: 2,
      title: 'Growth Cycles',
      linkTo: '/growth_cycles',
    },
    {
      id: 3,
      title: 'To Do',
      linkTo: '/todo',
    },
    {
      id: 4,
      title: 'Planning',
      linkTo: '/planning',
    },
    {
      id: 5,
      title: 'Analytics',
      linkTo: '/analytics',
    },
    {
      id: 6,
      title: 'Setup',
      linkTo: '/setup/users',
    },
    {
      id: 7,
      title: 'Account',
      linkTo: '/account',
    },
  ];

  private navigationDrawerOpen = false;

  private get isLoading() {
    return this.$store.state.messages.loading;
  }

  private get errorMessage() {
    return this.$store.state.messages.error;
  }

  private clearError() {
    this.$store.dispatch('setError', '');
  }

  private created() {
    this.$store.dispatch('getFarms');

    this.$store.watch(
      (state) => {
        return this.$store.state.currentFarm;
      },
      (newVal: Farm) => {
        this.currentFarm = newVal;
      },
    );
  }

  private updateCurrentFarmState(farmId: string) {
    // this only returns one result because IDs are guaranteed unique
    const newFarm = this.farmsState.filter((farm: Farm) => farm.id === farmId)[0];

    this.$store.dispatch('setCurrentFarm', newFarm);
  }

  private logout(): void {
    firebase.auth().signOut().then(() => this.$router.replace('/login'));
  }
}
